import { REP_BUCKETS, type PersonalRecord } from "../../../shared/src";

interface Props {
  records: PersonalRecord[];
}

function formatKg(value: number): string {
  return (Math.round(value * 10) / 10).toFixed(1);
}

export function PersonalRecordBadges({ records }: Props) {
  if (records.length === 0) {
    return (
      <p className="text-sm text-slate-400" role="status">
        No personal records yet — finish a workout to start tracking PRs.
      </p>
    );
  }

  const byBucket = new Map(records.map((r) => [r.bucket, r] as const));

  return (
    <ul
      className="grid grid-cols-2 gap-2 sm:grid-cols-5"
      aria-label="personal records by rep range"
    >
      {REP_BUCKETS.map((b) => {
        const pr = byBucket.get(b.key);
        return (
          <li
            key={b.key}
            className="rounded-lg border border-slate-800 bg-slate-900 p-3"
            data-bucket={b.key}
          >
            <div className="text-xs text-slate-400">{b.label}</div>
            {pr ? (
              <>
                <div className="mt-1 text-lg font-semibold tabular-nums">
                  {formatKg(pr.weight_kg)} × {pr.reps}
                </div>
                <div className="text-xs text-orange-400 tabular-nums">
                  e1RM {formatKg(pr.e1rm)} kg
                </div>
              </>
            ) : (
              <div className="mt-1 text-sm text-slate-500">—</div>
            )}
          </li>
        );
      })}
    </ul>
  );
}
